<ng-container [ngSwitch]="currentButtonType$ | async">
  <button
    *ngSwitchCase="buttonType.Primary"
    mat-raised-button
    [attr.test-id]="testId || (action | lowercase) + '-button'"
    [ngClass]="classByAction"
    [class]="size"
    [disabled]="disabled"
    (click)="buttonClick.emit()"
  >
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="textTemplate"></ng-container>
  </button>
  <button
    *ngSwitchCase="buttonType.Secondary"
    mat-button
    [attr.test-id]="testId || (action | lowercase) + '-button'"
    [ngClass]="classByAction"
    [class]="size"
    [disabled]="disabled"
    (click)="buttonClick.emit()"
  >
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="textTemplate"></ng-container>
  </button>
  <button
    *ngSwitchCase="buttonType.Custom"
    mat-raised-button
    class="custom-button"
    (click)="buttonClick.emit()"
    [disabled]="disabled"
  >
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="textTemplate"></ng-container>
  </button>
</ng-container>

<ng-template #iconTemplate>
  <ng-container [ngSwitch]="action">
    <ui-svg-icon *ngSwitchCase="buttonAction.Update" [name]="iconNames.Save"></ui-svg-icon>
    <ui-svg-icon *ngSwitchCase="buttonAction.Save" [name]="iconNames.Save"></ui-svg-icon>
    <ui-svg-icon *ngSwitchCase="buttonAction.Approve" [name]="iconNames.Checkmark"></ui-svg-icon>
    <ui-svg-icon *ngSwitchCase="buttonAction.Delete" [name]="iconNames.Delete"></ui-svg-icon>
    <ui-svg-icon *ngSwitchCase="buttonAction.Continue" [name]="iconNames.ArrowRight"></ui-svg-icon>
    <ui-svg-icon *ngSwitchCase="buttonAction.GoBack" [name]="iconNames.ArrowLeft"></ui-svg-icon>
    <ui-svg-icon *ngSwitchCase="buttonAction.Clone" [name]="iconNames.Copy"></ui-svg-icon>
    <ui-svg-icon *ngSwitchCase="buttonAction.Activate" [name]="iconNames.Checkmark"></ui-svg-icon>
    <ui-svg-icon *ngSwitchCase="buttonAction.Deactivate" [name]="iconNames.Close"></ui-svg-icon>
  </ng-container>
</ng-template>

<ng-template #textTemplate>
  {{ text ? text : ('common.button.' + (action.toLowerCase() | camelCase) | translate) }}
</ng-template>
